<template>
    <div class="customer-analysis-content">
        <div class="right-wrapper">
            <div class="right-header">
                <div class="header-tab">
                    <div class="item-tab activeSelect">
                        <span>数据分析</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="analysis-content">
            <el-breadcrumb separator="/" class="breadcrumb">
                <el-breadcrumb-item>店铺引流</el-breadcrumb-item>
                <el-breadcrumb-item>数据分析</el-breadcrumb-item>
                <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="header">广告数据</div>
            <div class="customer-analysis-tab">
                <el-tabs
                    v-model="activeName"
                    @tab-click="handleClick"
                    class="customer-analysis-el-tabs"
                >
                    <el-tab-pane label="展位广告" name="展位广告" :lazy="true">
                        <BoothAd></BoothAd>
                    </el-tab-pane>
                    <el-tab-pane label="搜索广告" name="搜索广告" :lazy="true">
                        <SearchAd></SearchAd>
                    </el-tab-pane>
                    <el-tab-pane label="热门关键词" name="热门关键词">
                        <HotKeyWord></HotKeyWord>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import BoothAd from '../../../../components/student/operationPromotion/shopDrainage/customerAnalysis/BoothAd.vue';
import SearchAd from '../../../../components/student/operationPromotion/shopDrainage/customerAnalysis/SearchAd.vue';
import HotKeyWord from '../../../../components/student/operationPromotion/shopDrainage/customerAnalysis/HotKeyWord.vue';

export default {
    name: 'CustomerAnalysis',
    data() {
        return {
            activeName: '展位广告',
        };
    },
    components: {
        BoothAd,
        SearchAd,
        HotKeyWord,
    },
    created() {
        switch (Number(this.$route.query.type)) {
            case 1:
                this.activeName = '展位广告';
                break;
            case 2:
                this.activeName = '搜索广告';
                break;
            case 3:
                this.activeName = '热门关键词';
                break;
        }
    },
    methods: {
        handleClick() {},
    },
};
</script>

<style scoped lang="scss">
.customer-analysis-content {
    min-height: calc(100vh - 120px);
    .header {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #343434;
        margin: 20px 0;
    }
    .customer-analysis-tab {
        min-height: calc(100vh - 246px);
        background-color: #fff;
        ::v-deep .customer-analysis-el-tabs {
            min-height: calc(100vh - 246px);
            background-color: #fff;
            .el-tabs__item {
                margin-top: 10px;
                padding-left: 20px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;
                &.is-active {
                    color: #fd4446;
                }
            }
            .el-tabs__active-bar {
                background-color: #fd4446;
            }
            .el-tabs__content {
                /*height: calc(100% - 65px);*/
                .el-tab-pane {
                    min-height: calc(100vh - 267px);
                }
            }
            .el-tabs__nav-wrap::after {
                background-color: #fff;
            }
        }
    }
}
.analysis-content {
    padding: 20px 30px 20px 40px;
    background: #f7f9fb;
    box-sizing: border-box;
}
.right-wrapper {
    display: flex;
    flex-direction: column;
    .right-header {
        height: 80px;
        background: #fff;
        border-bottom: 1px solid #d1d2db;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .header-tab {
            height: 100%;
            position: absolute;
            left: 30px;
            display: flex;
            align-items: center;
            font-weight: 500;
            color: #333333;
            .activeSelect {
                span {
                    display: block;
                    height: 100%;
                    color: #fd4446 !important;
                    border-bottom: 2px solid #fd4446 !important;
                }
            }
            .item-tab {
                height: 100%;
                margin-right: 25px;
                cursor: pointer;
                line-height: 81px;
                border-bottom: 2px solid transparent;
                font-size: 20px;
                span {
                    color: #333333;
                    &:hover {
                        color: #fd4446;
                    }
                }
            }
        }
    }
}
</style>
